import * as navigation from 'Navigation';

class AaSequenceComplexPreviewTabState extends navigation.TabState {
  constructor({proteinIds}: {proteinIds: Array<string>}) {
    super();
    this.set('proteinIds', proteinIds);
  }

  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'AA Sequence Preview',
      closeable: true,
    };
  }
}

export {AaSequenceComplexPreviewTabState as tabState};
